import { gql } from '@apollo/client'

export default gql`
  mutation generatePassword($userId: ID!) {
    generatePassword(userId: $userId)
  }
`
